module.exports = __webpack_public_path__ + "static/moviearcbg-348361474f8edaf424f745ab085d403f.jpg";